// src/pages/SermonMessages.js
import React, { useState, useEffect, useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { GlobalContext } from '../contexts/GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import './PastorMessages.css';

function SermonMessages() {
  const [sermonMessages, setSermonMessages] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { resultsPerPage, setResultsPerPage } = useContext(GlobalContext);

  // Use search parameters
  const [searchParams, setSearchParams] = useSearchParams();

  // Initialize page from URL or default value
  const initialPage = parseInt(searchParams.get('page')) || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);

  useEffect(() => {
    fetchMessages(currentPage, resultsPerPage);

    // Update the URL query parameters
    setSearchParams({ page: currentPage, limit: resultsPerPage }, { replace: false });
  }, [currentPage, resultsPerPage, setSearchParams]);

  const fetchMessages = async (page, limit) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/getSermonMessages?page=${page}&limit=${limit}`
      );
      const data = await response.json();
      setSermonMessages(data.sermons);
      setTotalPages(data.totalPages);
      setCurrentPage(data.currentPage);
    } catch (error) {
      console.error('Error fetching sermon messages:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-content">
      <h2>講台信息</h2>
      <h4>前往 YouTube 點播 2020年4月以後的講台信息</h4>
      <a href="https://youtube.com/@hocsf234/featured" target="_blank" rel="noopener noreferrer">
        <button className="button button-xl">
          <FontAwesomeIcon icon={faYoutube} size="1x" /> &nbsp;YouTube 頻道
        </button>
      </a>
      <br />
      <br />
      <hr />
      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        resultsPerPage={resultsPerPage}
        setResultsPerPage={setResultsPerPage}
      />
      {isLoading ? (
        <p>載入中...</p>
      ) : sermonMessages.length > 0 ? (
        <ul className="messages-list">
          {sermonMessages.map((message) => (
            <li key={message.submission_id}>
              <Link to={`/sermon-messages/read/${message.submission_id}`} title={message.title}>
                <h3>
                  {new Date(message.date).toLocaleDateString()} - {message.title}
                </h3>
                講員：{message.speaker}
                <br />
                經文：{message.bible}
                <br />
              </Link>
              <hr />
            </li>
          ))}
        </ul>
      ) : (
        <p>目前沒有講台信息。</p>
      )}
      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        resultsPerPage={resultsPerPage}
        setResultsPerPage={setResultsPerPage}
      />
    </div>
  );
}

export default SermonMessages;